import { apiCall } from "./api";

const URL = "/api/v1/manage-dashboard/data-cleanup";

const options = (method, body) => ({
  method,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  credentials: "include",
  ...(body ? { body: JSON.stringify(body) } : {}),
});

/** Find dead workspaces/users and list them as "watching". Nothing is changed. */
export const runCleanupScan = () => apiCall(`${URL}/scan`, options("POST", {}));

export const getCleanupSummary = () =>
  apiCall(`${URL}/summary`, options("GET"));

/** Which database and billing service the backend is using, and whether billing answers. */
export const getCleanupEnvironment = () =>
  apiCall(`${URL}/environment`, options("GET"));

/** params: { status, type, used: "true" | "false", search, limit, offset } */
export const getCleanupCandidates = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
  ).toString();
  return apiCall(
    `${URL}/candidates${query ? `?${query}` : ""}`,
    options("GET"),
  );
};

/**
 * The database side of the full report: active workspaces, users (with their
 * test-account check) and the cleanup list. Billing is read separately.
 */
export const getCleanupReportData = () =>
  apiCall(`${URL}/report-data`, options("GET"));

export const getCleanupCandidateHits = (candidateId) =>
  apiCall(`${URL}/candidates/${candidateId}/hits`, options("GET"));

/**
 * Delete (archive, then remove). With dryRun, only says what would be removed
 * and what would be skipped, and why.
 */
export const deleteCleanupCandidates = (ids, dryRun = false) =>
  apiCall(
    `${URL}/delete`,
    options("POST", dryRun ? { ids, dryRun: true } : { ids }),
  );

export const restoreCleanupCandidates = (ids) =>
  apiCall(`${URL}/restore`, options("POST", { ids }));

export const excludeCleanupCandidates = (ids) =>
  apiCall(`${URL}/exclude`, options("POST", { ids }));

/** Undo Keep: put Kept items back under review. */
export const reviewCleanupCandidates = (ids) =>
  apiCall(`${URL}/review`, options("POST", { ids }));
